export const codeToArray = (code?: string): string[] => code?.split("") ?? [];

export default { codeToArray }